import { type TrackWrapperProps } from '@/common/TrackWrapper';

type OwnProps = {
  index: number;
  isConditionalTile: boolean;
  isSimilarVehicle: boolean;
  totalTiles: number;
  searchRequestId: string;
  previousSearchRequestId: string;
};

export default function getTileWrapperProps({
  index,
  isConditionalTile,
  isSimilarVehicle,
  previousSearchRequestId,
  searchRequestId,
  totalTiles
}: OwnProps): TrackWrapperProps {
  const position = index + 1;

  return {
    delay: 0,
    event: {
      eventName: 'SRP Viewed',
      customAttributes: {
        isConditionalTile,
        isSimilarVehicle,
        module: 'SRP Tile',
        position,
        previousSearchRequestId,
        searchRequestId,
        totalTiles
      }
    },
    shouldTrack: position % 4 === 0, // Only track every 4th tile
    threshold: 0.5,
    trackOnce: true
  };
}
